// Keep structured listing data aligned with the full product cards rendered
// during the initial server pass. Remaining catalog products retain lightweight
// crawlable anchors, but are not visible product cards until virtualization
// mounts them in the browser.
export const INITIAL_SSR_PRODUCT_CARD_COUNT = 8;

export function initialSsrProductCards<T>(
  products: readonly T[] | null | undefined
): T[] {
  if (!Array.isArray(products)) return [];
  return products.slice(0, INITIAL_SSR_PRODUCT_CARD_COUNT);
}
